module.exports = __webpack_public_path__ + "img/ic-complete.222b18d6.svg";